import { render } from "./Questions.vue?vue&type=template&id=2e234e5f"
import script from "./Questions.vue?vue&type=script&lang=ts"
export * from "./Questions.vue?vue&type=script&lang=ts"
script.render = render

export default script